// extracted by mini-css-extract-plugin
export default {"closeIcon":"nKGfw4fW2vApk2FtDuBJ","container":"eWoJAlfj1kkQwXScgfQE","footerActions":"hUoYKsDCF1AD4kCeVE9T","storiesTest":"nZ5vcZHv1WvGKWH3WCKl","videoLoader":"C6z7wuYWoXjAHOTPSre_"};